import React, { Fragment } from 'react';
import BaggageUploadComponent from '../../components/ccd-baggage-img-upload/baggage-upload.component';
const styles = require('./ccd-baggage-upload.scss');

declare var exponea: any;
interface IProps {
  trackingData: any;
  language: string;
  multiLang: any;
  userBookingRef: string;
  getData: Function;
  queryParams: any;
  userEmail: string;
}

interface IState {
  loaded: boolean;
}

class CcdBaggageUploadComponent extends React.Component<IProps, IState> {
  public bookingProductService = null;
  constructor(props: any) {
    super(props);
    this.state = {
      loaded: false,
    };
  }

  componentDidMount() {
    this.setState({ loaded: true });
    exponea.track('tracking_screen', {
      page_name: 'CcdBaggageUpload',
      product_type: 'ccd',
    });
  }

  public render() {
    const { loaded } = this.state;

    const { trackingData, language, multiLang, userEmail } = this.props;
    console.log(trackingData);
    return (
      <Fragment>
        {loaded ? (
          <div className={styles.mainContent}>
            <div className={styles.sectionWrapperContent}>
              <div className={styles.section}>
                <BaggageUploadComponent
                  language={language}
                  multiLang={multiLang}
                  getData={() => this.props.getData()}
                  bookingJourneyReference={trackingData.bookingJourneyReference}
                  userBookingRef={this.props.userBookingRef}
                  trackingData={trackingData}
                  queryParams={this.props.queryParams}
                  userEmail={userEmail}
                ></BaggageUploadComponent>
              </div>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default CcdBaggageUploadComponent;



// WEBPACK FOOTER //
// ./src/containers/ccd-baggage-upload/ccd-baggage-upload.tsx